import { lazy } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { App } from "./App";
import { DEFAULT_ROUTES } from "./constants/routes";

import { BookingCreate } from "./pages/private-room/booking-create";
import BokaoList from "./pages/private-room/bookings";

const Signin = lazy(() => import("@/pages/signin"));

export function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={DEFAULT_ROUTES.INDEX} element={<App />}>
          <Route index element={<Navigate to={DEFAULT_ROUTES.SIGNIN} />} />
          <Route path={DEFAULT_ROUTES.SIGNIN} element={<Signin />} />
          <Route path={DEFAULT_ROUTES.BOOKINGS} element={<BokaoList />} />
          <Route
            path={DEFAULT_ROUTES.BOOKING_CREATE}
            element={<BookingCreate />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
